import * as React from 'react';
import { useRouteError } from 'react-router';
import { CustomerFacingError } from 'utils/ui/errors';
import { EErrorCode } from 'config/errors-codes';
import ErrorBoundary from './ErrorBoundary';
import SessionUnavailable from 'containers/SessionUnavailable';

const CustomerErrorBoundary: React.FC = () => {
  const error = useRouteError();
  if (error instanceof CustomerFacingError && error.code === EErrorCode.SESSION_DELETED) {
    return <SessionUnavailable />;
  }
  return <ErrorBoundary />;
};

export default CustomerErrorBoundary;
